// extracted by mini-css-extract-plugin
export var infoRow = "_pa-2";
export var labelContainer = "_pa-0";
export var rightInfo = "_pa-1";